<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.959999940395356,7C13.959999940395356,7,11.999999940395355,7,11.999999940395355,7C11.999999940395355,7,11.999999940395355,3.95,11.999999940395355,3.95C11.999999940395355,1.77,10.209999940395356,0,7.999999940395355,0C5.789999940395355,0,3.9999999403953552,1.77,3.9999999403953552,3.95C3.9999999403953552,3.95,3.9999999403953552,7,3.9999999403953552,7C3.9999999403953552,7,1.9599999403953552,7,1.9599999403953552,7C1.4099999403953551,7,0.9999999403953552,7.35,0.9999999403953552,7.9C0.9999999403953552,7.9,0.9999999403953552,14.81,0.9999999403953552,14.81C0.9999999403953552,15.35,1.4099999403953551,16,1.9599999403953552,16C1.9599999403953552,16,13.959999940395356,16,13.959999940395356,16C14.509999940395355,16,14.999999940395355,15.35,14.999999940395355,14.81C14.999999940395355,14.81,14.999999940395355,7.9,14.999999940395355,7.9C14.999999940395355,7.35,14.509999940395355,7,13.959999940395356,7C13.959999940395356,7,13.959999940395356,7,13.959999940395356,7ZM5.999999940395355,7C5.999999940395355,7,5.999999940395355,3.95,5.999999940395355,3.95C5.999999940395355,2.86,6.899999940395356,1.98,7.999999940395355,1.98C9.099999940395355,1.98,9.999999940395355,2.86,9.999999940395355,3.95C9.999999940395355,3.95,9.999999940395355,7,9.999999940395355,7C9.999999940395355,7,5.999999940395355,7,5.999999940395355,7C5.999999940395355,7,5.999999940395355,7,5.999999940395355,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Lock',
} as DefineComponent
</script>
